import React from "react";

const CmykSmall = ({ width = 25, height = 100 }) => {
  const barHeight = height / 4; // Each bar gets an equal portion of the height

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Cyan */}
      <rect x="0" y="0" width={width} height={barHeight} fill="#00FFFF" />
      {/* Yellow */}
      <rect x="0" y={barHeight} width={width} height={barHeight} fill="#FFFF00" />
      {/* Magenta */}
      <rect x="0" y={barHeight * 2} width={width} height={barHeight} fill="#FF00FF" />
      {/* Black */}
      <rect x="0" y={barHeight * 3} width={width} height={barHeight} fill="#000000" />
    </svg>
  );
};

export default CmykSmall;
